import { render } from "./ResellerInfoW.vue?vue&type=template&id=061185b9&scoped=true"
import script from "./ResellerInfoW.vue?vue&type=script&lang=js"
export * from "./ResellerInfoW.vue?vue&type=script&lang=js"

import "./ResellerInfoW.vue?vue&type=style&index=0&id=061185b9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-061185b9"]])

export default __exports__